import { useEffect, useRef, useState } from "react";

/* Плавное появление секций при прокрутке — аналог IntersectionObserver из app.js */
export default function useReveal() {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const el = ref.current;
        if (!el) return undefined;

        if (!("IntersectionObserver" in window)) {
            setVisible(true);
            return undefined;
        }

        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setVisible(true);
                        io.unobserve(entry.target);
                    }
                });
            },
            { rootMargin: "0px 0px -60px 0px" }
        );
        io.observe(el);

        const failsafe = setTimeout(() => setVisible(true), 2500);

        return () => {
            io.disconnect();
            clearTimeout(failsafe);
        };
    }, []);

    return [ref, visible];
}
